module.exports = __webpack_public_path__ + "img/module7.2c142e17.png";